import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { useMemo } from 'react'
import _ from 'lodash'
import VStack from 'components/atoms/stack/VStack'
import Text from "theme/Text";
import HelperDate, { dateFormat } from 'utils/helper-date'
import ThemedBlock from 'components/atoms/ThemedBlock'
import HelperString from 'utils/helper-string'
import Translate from 'utils/translate'

const AppMessages = () => {
	
	const currentTime = HelperDate.date();
	const _appMessages = useSelector( state => {
		return state.data[dataConstants.APP_MESSAGES];
	} );
	
	const messages = useMemo( () => {
		const result = [];
		_.forEach( _appMessages, ( message ) => {
			if( message.active === 'yes' ) {
				const dateStart = HelperDate.date( message.date_start, dateFormat.DATE );
				const dateEnd = HelperDate.date( message.date_end, dateFormat.DATE );
				
				if( currentTime.isBetween( dateStart, dateEnd ) ) {
					result.push( message );
				}
			}
		})
		
		return result
	}, [ _appMessages ] )
	
	if( _.size( messages ) === 0 ) {
		return null
	}
	
	return (
		<VStack>
			{ _.map( messages, ( message ) => {
				
				const title = Translate.field( message, 'title' )
				const description = Translate.field( message, 'description' )
				
				return (
					<ThemedBlock
						key={ HelperString.hash( "app-message-item", message.id ) }
						shadow
						mediumPadding>
						
						{ title && (
							<Text category={ 's1' }>{ title }</Text>
						)}
						
						<Text>{ description }</Text>
					</ThemedBlock>
				)
			})}
		</VStack>
	)
}

export default AppMessages
